'use strict';

const PDF_MIME = 'application/pdf';
const PDF_EXTENSION = '.pdf';
const DEFAULT_MAX_BYTES = 10 * 1024 * 1024; // 10 MB

const formatFileSize = (bytes) => {
	const value = Number(bytes);
	if (!Number.isFinite(value) || value < 0) return '';
	if (value < 1024) return `${value} B`;
	if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
	return `${(value / (1024 * 1024)).toFixed(1)} MB`;
};

/**
 * Validate a File for SPE dismiss approve attachment.
 * @returns {{ ok: true, file: File } | { ok: false, error: string }}
 */
const validatePdfAttachment = (file, options = {}) => {
	if (!file) {
		return { ok: false, error: 'Attachment (PDF) is required.' };
	}

	const maxBytes = Number(options.maxBytes) > 0 ? Number(options.maxBytes) : DEFAULT_MAX_BYTES;
	const name = String(file.name || '').trim();
	const mime = String(file.type || '').toLowerCase();
	const isPdfMime = !mime || mime === PDF_MIME;
	const isPdfName = name.toLowerCase().endsWith(PDF_EXTENSION);

	if (!isPdfMime || !isPdfName) {
		return { ok: false, error: 'Only PDF files are allowed.' };
	}

	if (Number(file.size) > maxBytes) {
		return {
			ok: false,
			error: `PDF must be ${formatFileSize(maxBytes)} or smaller.`,
		};
	}

	return { ok: true, file };
};

module.exports = {
	PDF_MIME,
	PDF_EXTENSION,
	DEFAULT_MAX_BYTES,
	formatFileSize,
	validatePdfAttachment,
};
